import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'Login',
		component: () => import('../views/Login.vue'),
	},
	{
		path: '/home',
		name: 'Home',
		component: Home,
		children: [		{
			path: '/work',
			name: 'Work',
			component: () => import('../views/Work/Work.vue'),
		}, {
			path: '/weekrecordslist',
			name: 'WeekRecordsList',
			component: () => import('../views/Work/WeekRecordsList.vue'),
		}, {
			path: '/taskplan',
			name: 'TaskPlan',
			component: () => import('../views/Work/TaskPlan.vue'),
		}, {
			path: '/projectfollowup',
			name: 'projectfollowup',
			component: () => import('../views/Work/projectfollowup.vue'),
		}, {
			path: '/taskfollowup',
			name: 'taskfollowup',
			component: () => import('../views/Work/taskfollowup.vue'),
		}, {
			path: '/taskrkfollowup',
			name: 'taskrkfollowup',
			component: () => import('../views/Work/taskrkfollowup.vue'),
		}, {
			path: '/project',
			name: 'Project',
			component: () => import('../views/Form/Project.vue'),
		}, {
			// 内部项目管理：与项目管理同一组件，仅查看类别为公司内部项目
			path: '/projectinternal',
			name: 'ProjectInternal',
			component: () => import('../views/Form/Project.vue'),
		}, {
			path: '/tasklist/:taskid',
			name: 'TaskList',
			component: () => import('../views/Form/TaskList.vue'),
		}, {
			path: '/user',
			name: 'User',
			component: () => import('../views/System/User.vue'),
		}, {
			path: '/password',
			name: 'PassWord',
			component: () => import('../views/System/PassWord.vue'),
		},{
			path: '/loglist',
			name: 'Loglist',
			component: () => import('../views/System/Loglist.vue'),
		}, {
			path: '/permissions',
			name: 'Permissions',
			component: () => import('../views/System/Permissions.vue'),
		},{
			path: '/tjyuqiuser',
			name: 'tjyuqiuser',
			component: () => import('../views/Tj/tjyuqiuser.vue'),
		}, {
			path: '/department',
			name: 'Department',
			component: () => import('../views/System/Department.vue'),
		}, {
			path: '/base',
			name: 'Base',
			component: () => import('../views/Work/Base.vue'),
		}, {
			path: '/ceshi',
			name: 'CeShi',
			component: () => import('../views/CeShi.vue'),
		}, {
			path: '/configlist',
			name: 'ConfigList',
			component: () => import('../views/Zc/ConfigList.vue'),
		}, {
			path: '/sbxxlist',
			name: 'SbxxList',
			component: () => import('../views/Zc/SbxxList.vue'),
		}, {
			path: '/zclist',
			name: 'ZcList',
			component: () => import('../views/Zc/ZcList.vue'),
		}, {
			path: '/role',
			name: 'Role',
			component: () => import('../views/System/Role.vue'),
		}, {
			path: '/projectstepstatuslist',
			name: 'ProjectStepStatusList',
			component: () => import('../views/Form/projectstepstatuslist.vue'),
		}, {
			path: '/alltask',
			name: 'AllTask',
			component: () => import('../views/Form/AllTask.vue'),
		},{
			path: '/allbd',
			name: 'Allbd',
			component: () => import('../views/bd/Allbd.vue'),
		},{
			path: '/selfbd',
			name: 'selfbd',
			component: () => import('../views/bd/selfbd.vue'),
		}, {
			path: '/jiashic',
			name: 'jiashic',
			component: () => import('../views/Tj/jiashic.vue'),
		},{
			path: '/jlrwtj',
			name: 'jlrwtj',
			component: () => import('../views/Tj/jlrwtj.vue'),
		},{
			path: '/jlrwhz',
			name: 'jlrwhz',
			component: () => import('../views/Tj/jlrwhz.vue'),
		},{
			path: '/derwhz',
			name: 'derwhz',
			component: () => import('../views/Tj/derwhz.vue'),
		},{
			path: '/projectweekstatuslist',
			name: 'projectweekstatuslist',
			component: () => import('../views/Tj/projectweekstatuslist.vue'),
		},{
			path: '/projectfollowupxxts',
			name: 'projectfollowupxxts',
			component: () => import('../views/Tj/projectfollowupxxts.vue'),
		},{
			path: '/gjcstj',
			name: 'gjcstj',
			component: () => import('../views/Tj/gjcstj.vue'),
		},{
			path: '/usergroup',
			name: 'usergroup',
			component: () => import('../views/System/usergroup.vue'),
		},{
			path: '/newtasklog',
			name: 'newtasklog',
			component: () => import('../views/Form/NewTaskLog.vue'),
		},{
			path: '/tjfinishday',
			name: 'tjfinishday',
			component: () => import('../views/Tj/tjfinishday.vue'),
		},{
			path: '/tjjianmo',
			name: 'tjjianmo',
			component: () => import('../views/Tj/tjjianmo.vue'),
		},{
			path: '/jianmolist',
			name: 'jianmolist',
			component: () => import('../views/Form/jianmolist.vue'),
		},{
			path: '/jianmotj',
			name: 'jianmotj',
			component: () => import('../views/Form/jianmotj.vue'),
		},{
			path: '/postsaleanalysis',
			name: 'postsaleanalysis',
			component: () => import('../views/Tj/postsaleanalysis.vue'),
		},{
			path: '/postsaleanalysisfine',
			name: 'postsaleanalysisfine',
			component: () => import('../views/Tj/postsaleanalysisfine.vue'),
		},{
			path: '/configlist3',
			name: 'configlist3',
			component: () => import('../views/SH/configlist.vue'),
		},{
			path: '/postsaleanalysislist',
			name: 'postsaleanalysislist',
			component: () => import('../views/SH/postsaleanalysislist.vue'),
		}, {
			path: '/projectstatus',
			name: 'projectstatus',
			component: () => import('../views/project/projectstatus.vue'),
		}, {
			path: '/projectlog',
			name: 'ProjectLog',
			component: () => import('../views/project/ProjectLog.vue'),
		}, {
			path: '/formtemplate',
			name: 'FormTemplate',
			component: () => import('../views/Form/FormTemplate.vue'),
		}, {
			path: '/forminstancelist',
			name: 'FormInstanceList',
			component: () => import('../views/Form/FormInstanceList.vue'),
		},{
			path: '/derwmxlist',
			name: 'derwmxlist',
			component: () => import('../views/Tj/derwmxlist.vue'),
		},{
			path: '/taskquery',
			name: 'TaskQuery',
			component: () => import('../views/Form/TaskQuery.vue'),
		},{
			path: '/datacollecttemplate',
			name: 'DataCollectTemplate',
			component: () => import('../views/Form/DataCollectTemplate.vue'),
		},{
			path: '/datacollectadd',
			name: 'DataCollectAdd',
			component: () => import('../views/Form/DataCollectAdd.vue'),
		},		{
			path: '/tasktypeconfig',
			name: 'TaskTypeConfig',
			component: () => import('../views/Form/TaskTypeConfig.vue'),
		}, {
			path: '/formrejecttj',
			name: 'FormRejectTj',
			component: () => import('../views/Tj/formrejecttj.vue'),
		}, {
			path: '/systemconfig',
			name: 'SystemConfig',
			component: () => import('../views/Form/SystemConfig.vue'),
		}, {
			// 统计报表-信息报备统计
			path: '/projectreporttj',
			name: 'ProjectReportTj',
			component: () => import('../views/Tj/projectreporttj.vue'),
		}, {
			// 统计报表-月度任务导出
			path: '/monthtasktj',
			name: 'MonthTaskTj',
			component: () => import('../views/Tj/monthtasktj.vue'),
		}, {
			// 统计报表-签字流程逾期统计
			path: '/formoverduetj',
			name: 'FormOverdueTj',
			component: () => import('../views/Tj/formoverduetj.vue'),
		}, {
			// 售后数据-PDCA问题改善（独立表，与项目管理任务分开）
			path: '/pdca',
			name: 'Pdca',
			component: () => import('../views/SH/pdca.vue'),
		}, {
			// 售后数据-客户投诉（手机端 tel_complaint.html 提交数据）
			path: '/complaintlist',
			name: 'ComplaintList',
			component: () => import('../views/SH/complaintlist.vue'),
		}, {
			// 竞品档案-企业信息
			path: '/competinginfo',
			name: 'CompetingInfo',
			component: () => import('../views/Competing/CompetingList.vue'),
			meta: { type1: '企业信息' },
			props: (route: any) => ({ type1: route.meta?.type1 || '企业信息' })
		}, {
			// 竞品档案-企业动态
			path: '/competingdynamic',
			name: 'CompetingDynamic',
			component: () => import('../views/Competing/CompetingList.vue'),
			meta: { type1: '企业动态' },
			props: (route: any) => ({ type1: route.meta?.type1 || '企业动态' })
		}, {
			// 知识库-订单计划思维导图（iframe 嵌入 views/订单计划思维导图7.0.html）
			path: '/mindmap',
			name: 'MindMap',
			component: () => import('../views/KB/MindMap.vue'),
		}, {
			// 知识库-模板文件（遍历 views/各部门表单 目录并提供下载）
			path: '/formfiles',
			name: 'FormFiles',
			component: () => import('../views/KB/FormFiles.vue'),
			}, {
			// 知识库-更新记录（时间轴展示，由近到远）
			path: '/updaterecord',
			name: 'UpdateRecord',
			component: () => import('../views/KB/UpdateRecord.vue'),
			}, {
			// 知识库-流程表单对照表（事项名称 + 动态流程明细 + 多文件带名称）
			path: '/processform',
			name: 'ProcessForm',
			component: () => import('../views/KB/ProcessForm.vue'),
			}, {
			// 表单管理-项目信息报备
			path: '/projectreport',
			name: 'ProjectReport',
			component: () => import('../views/Form/ProjectReport.vue'),
			}, {
			// 表单管理-签字表单汇总
			path: '/signformsummary',
			name: 'SignFormSummary',
			component: () => import('../views/Form/SignFormSummary.vue'),
			}
			]
		}
]

const router = createRouter({
	history:createWebHashHistory(),
	routes
})

export default router
